import { shouldShowRscLoggedInSearchPage } from "@faire/retailer-visitor-shared/views/search-v2/util/shouldShowRscLoggedInSearchPage";

const getSettingRscProductTileLoggedInSearchPage = (): boolean => {
  return true;
};

export const shouldShowRscProductTileLoggedInSearchPage = (): boolean => {
  return (
    shouldShowRscLoggedInSearchPage() &&
    getSettingRscProductTileLoggedInSearchPage()
  );
};
